import React from 'react';
import Chip from '@material-ui/core/Chip';
import { withStyles } from '@material-ui/core/styles';

const styles = {
  chipMargin: {
    margin: '3px 5px 3px 0',
  },
};

const EmployeeChipsField = withStyles(styles)(({ record, source, classes }) => {
  const types = record[source];
  if (!types) {
    return null;
  }
  types.sort();
  return types.map((item) => (
    <Chip
      key={item.email_address}
      label={item.email_address}
      className={classes.chipMargin}
    />
  ));
});
EmployeeChipsField.defaultProps = {
  label: 'Employees',
  source: 'employees',
};

export default EmployeeChipsField;
